import React, { useState, useEffect } from 'react';
import { FiExternalLink } from 'react-icons/fi';

const News = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      // ÚJ MÓDSZER: Megkerüljük a CORS hibát az rss2json segítségével
      const RSS_URL = 'http://misz.hu/rss.xml';
      const API_URL = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(RSS_URL)}`;

      try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error('Hálózati hiba a letöltéskor.');
        
        const data = await response.json();

        if (data.status === 'ok') {
          // Feldolgozás az Androidos app logikája szerint
          const formattedItems = data.items.map(item => ({
            title: item.title,
            link: item.link,
            // Dátum formázása magyarra
            pubDate: new Date(item.pubDate).toLocaleDateString('hu-HU'),
            // Kép kinyerése (vagy enclosure-ből, vagy thumbnail-ből)
            imageUrl: item.enclosure?.link || item.thumbnail || null
          }));

          setNewsItems(formattedItems.slice(0, 9)); // Max 9 hír a rácshoz
        } else {
          throw new Error("Nem sikerült beolvasni az RSS-t.");
        }
      } catch (err) {
        console.error("Hírfolyam hiba:", err);
        setError("A MISZ hírek jelenleg nem érhetőek el.");
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  // --- STÍLUSOK (Androidos item_news.xml alapján) ---
  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
    padding: '10px 0'
  };

  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    textDecoration: 'none',
    color: '#333',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.2s ease',
    border: '1px solid #eee',
    height: '100%'
  };

  const imageStyle = {
    width: '100%',
    aspectRatio: '16/9', // Mint az appban a constraintDimensionRatio
    objectFit: 'cover',
    backgroundColor: '#f5f5f5'
  };

  if (loading) return <div style={{textAlign: 'center', padding: '3rem', color: '#b30000', fontWeight: 'bold'}}>Hírek betöltése...</div>;
  if (error) return null; // Hiba esetén ne rontsa el a főoldalt

  return (
    <div style={gridStyle}>
      {newsItems.map((item, index) => (
        <a 
          key={index} 
          href={item.link} 
          target="_blank" 
          rel="noopener noreferrer" 
          style={cardStyle}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          {item.imageUrl ? (
            <img src={item.imageUrl} alt="" style={imageStyle} />
          ) : (
            <div style={{...imageStyle, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc'}}>
               🏹 Archery Nexus
            </div>
          )}
          <div style={{ padding: '15px', flex: 1, display: 'flex', flexDirection: 'column' }}>
            <h3 style={{ 
              margin: '0 0 10px 0', 
              fontSize: '1rem', 
              color: '#b30000', 
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitLineClamp: 2, 
              WebkitBoxOrient: 'vertical',
              lineHeight: '1.4'
            }}>
              {item.title}
            </h3>
            
            <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
              <div>
                <div style={{ fontSize: '0.75rem', color: '#888' }}>{item.pubDate}</div>
                <div style={{ fontSize: '0.7rem', color: '#aaa', fontStyle: 'italic' }}>www.misz.hu</div>
              </div>
              <FiExternalLink size={20} color="#b30000" style={{ opacity: 0.7 }} />
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default News;